module.exports = __webpack_public_path__ + "img/conserve.2fa177ab.svg";